/** @file One Activity row's text: command names grouped (name ×n), up to five target names (+n). */
import type { CommitSummary } from '@pose2d/api/types';
import type { Translate } from '@pose2d/i18n/types';

const SHOWN_TARGETS = 5;

/** `bone.create ×2, slot.create` and `arm-L, arm-R +3` for one commit summary. */
export function commitLine(t: Translate, summary: CommitSummary): { commands: string; targets: string } {
  const counts = new Map<string, number>();
  for (const c of summary.commands) counts.set(c.name, (counts.get(c.name) ?? 0) + 1);
  const commands = [...counts].map(([name, n]) => (n === 1 ? name : t('activity.commandTimes', { name, n }))).join(', ');
  const targets = [...new Set(summary.commands.flatMap((c) => c.targets))];
  const shown = targets.slice(0, SHOWN_TARGETS).join(', ');
  const rest = targets.length - SHOWN_TARGETS;
  return { commands, targets: rest > 0 ? `${shown} ${t('activity.moreTargets', { n: rest })}` : shown };
}
